export const errorMessages = {
  serverError: 'error500',
  unauthorizedError: 'error401',
  networkUnavailable: 'networkUnavailableText',
  tenantErrorText: 'tenantErrorText'
} as const;
